import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function MentionsLegales() {
  return (
    <div className="bg-[#FAFAFA] text-[#1A1918] min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-28 md:pt-36 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#C86641]">◆ Informations</div>
          <h1 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95] mt-6" data-testid="mentions-title">
            Mentions légales.
          </h1>
          <p className="mt-4 text-[#5C5A56]">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

          <div className="prose-content mt-12 space-y-10 text-[15px] leading-relaxed text-[#1A1918]">
            <Section title="1. Éditeur du site">
              <p>
                Le présent site est édité par <strong>E-PRO.Intervention</strong>, micro-entreprise immatriculée en France.
              </p>
              <ul className="mt-3 space-y-1">
                <li><strong>Nom commercial :</strong> E-PRO.Intervention</li>
                <li><strong>Statut juridique :</strong> Micro-entreprise (Entreprise Individuelle)</li>
                <li><strong>Activité :</strong> Travaux de rénovation, installation cuisine et salle de bain, peinture, enduit, carrelage</li>
                <li><strong>Adresse du siège :</strong> <span className="text-[#5C5A56]">[À compléter par l'éditeur]</span></li>
                <li><strong>SIRET :</strong> <span className="text-[#5C5A56]">[À compléter par l'éditeur]</span></li>
                <li><strong>Numéro de TVA intracommunautaire :</strong> non applicable (franchise en base de TVA, article 293 B du CGI)</li>
                <li><strong>Téléphone :</strong> <a href="tel:0660413073" className="text-[#C86641]">06.60.41.30.73</a></li>
                <li><strong>Email :</strong> <a href="mailto:valdoise-95@hotmail.com" className="text-[#C86641]">valdoise-95@hotmail.com</a></li>
                <li><strong>Directeur de la publication :</strong> EL HYANI Zakaria</li>
              </ul>
            </Section>

            <Section title="2. Hébergement du site">
              <p>
                Le site est hébergé sur la plateforme <strong>Emergent</strong> (emergent.sh) qui assure la disponibilité technique
                et le stockage des données. Pour toute question relative à l'hébergement, vous pouvez écrire à l'éditeur,
                qui transmettra le cas échéant à l'hébergeur.
              </p>
            </Section>

            <Section title="3. Propriété intellectuelle">
              <p>
                L'ensemble des éléments figurant sur le site (textes, marques, logos, photographies, illustrations, mises en page,
                arborescence, etc.) sont la propriété exclusive de E-PRO.Intervention ou font l'objet d'une autorisation d'utilisation.
                Toute reproduction, représentation, modification, publication ou adaptation totale ou partielle, par quelque procédé
                que ce soit, est interdite sans l'autorisation écrite préalable de E-PRO.Intervention.
              </p>
              <p>
                Les photographies illustratives du site proviennent de banques d'images libres de droits (Unsplash, Pexels).
              </p>
            </Section>

            <Section title="4. Responsabilité">
              <p>
                E-PRO.Intervention s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur le site,
                sans toutefois garantir l'exactitude, l'exhaustivité ou l'actualité des informations mises à disposition.
                L'utilisateur du site reconnaît utiliser ces informations sous sa responsabilité exclusive.
              </p>
              <p>
                Les devis présentés sur le site sont indicatifs et ne constituent pas un engagement contractuel.
                Tout devis formel sera établi après visite et étude du projet.
              </p>
            </Section>

            <Section title="5. Liens hypertextes">
              <p>
                Le site peut contenir des liens vers des sites tiers. E-PRO.Intervention n'exerce aucun contrôle sur ces sites
                et décline toute responsabilité quant à leur contenu.
              </p>
            </Section>

            <Section title="6. Droit applicable et juridiction">
              <p>
                Les présentes mentions légales sont régies par le droit français. En cas de litige, et après échec de toute
                tentative de résolution amiable, les tribunaux français seront seuls compétents.
              </p>
            </Section>

            <Section title="7. Contact">
              <p>
                Pour toute question relative au site ou aux services, merci de nous contacter par téléphone
                au <a href="tel:0660413073" className="text-[#C86641]">06.60.41.30.73</a> ou par
                email à <a href="mailto:valdoise-95@hotmail.com" className="text-[#C86641]">valdoise-95@hotmail.com</a>.
              </p>
            </Section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-2xl md:text-3xl tracking-tight text-[#1A1918] mb-4 border-l-2 border-[#C86641] pl-4">
        {title}
      </h2>
      <div className="space-y-3 text-[#5C5A56]">{children}</div>
    </section>
  );
}
